import {Component, EventEmitter, HostBinding, Input, Output} from "@angular/core";
import {SelectorType} from "./selector";

@Component({
    selector: "woa-selector-control",
    templateUrl: "./selector-control.component.html",
})
export class SelectorControlComponent {
    SelectorType = SelectorType;

    @Input() type: SelectorType = SelectorType.CHECKBOX;
    @Input() selected: boolean = false;
    @Input() label: string;
    @Input() translationParams: any = {};
    @Input() @HostBinding("class.disabled") disabled: boolean = false;
    @Input() @HostBinding("class.touched") touched: boolean = false;

    @Output() selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onSelect: EventEmitter<void> = new EventEmitter();

    public select(event: MouseEvent) {
        event.stopPropagation();

        if (event.screenY === 0 && event.screenY === 0) {
            return;
        }

        this.onSelect.emit();
        if (this.type === SelectorType.RADIO && this.selected) {
            event.preventDefault();
            return;
        }
        this.selectedChange.emit(!this.selected);
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/selector-control/selector-control.component.ts